import { useState, useCallback } from 'react';
import useAuth from '../../../hooks/useAuth';
import { Box, Stack, Typography, Divider, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Menu as MenuClose, Home, AccountCircle, FormatListNumbered, MenuOpen, RequestQuote, FactCheck } from '@mui/icons-material';
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import Profile from '../../../pages/admin/profile/Profile';
import UserList from '../../../pages/admin/user-list/UserList';
import Transactions from '../../../pages/admin/transactions/Transactions';
import Requests from '../../../pages/admin/requests/Requests';

const SideBar = () => {

    const { user } = useAuth();

    const [collapsed, setCollapsed] = useState(false);
    const [activeComponent, setActiveComponent] = useState('Profile');

    const menus = ['Profile', 'User List', 'Transactions', 'Requests'];
    const theme = useTheme();

    const renderActiveComponent = () => {
        switch (activeComponent) {
            case 'Profile':
                return <Profile />;
            case 'User List':
                return <UserList />;
            case 'Transactions':
                return <Transactions />;
            case 'Requests':
                return <Requests />;
            default:
                return <Typography variant="body1">Select a Menu</Typography>;
        }
    };

    const getMenuIcon = useCallback((menu) => {
        const getIcon = (menu) => {
            switch (menu) {
                case 'Profile':
                    return <AccountCircle />;
                case 'User List':
                    return <FormatListNumbered />;
                case 'Transactions':
                    return <RequestQuote />;
                case 'Requests':
                    return <FactCheck />;
                default:
                    return <Home />;
            }
        };

        return (
            <IconButton sx={{ color: theme.mainColor }}>
                {getIcon(menu)}
            </IconButton>
        );
    }, [theme.mainColor]);


    return (
        <Box sx={{ display: "flex", height: 'calc(100vh - 65px)' }}>
            <Sidebar collapsed={collapsed} width="300px" sx={{ height: '100%', overflow: 'hidden' }}>
                <Stack
                    direction="row"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: 1,
                    }}
                >
                    {!collapsed && <Stack direction="row" alignItems={"center"} justifyContent={"center"}>
                        <Typography variant="h6" noWrap sx={{ pt: 0.2, pl: 2, fontSize: 27 }}>
                            {user["first_name"]}
                        </Typography>
                    </Stack>}
                    {collapsed ?
                        <IconButton onClick={() => setCollapsed(!collapsed)}>
                            <MenuClose sx={{ color: "black", pl: 1.5, fontSize: 28 }} />
                        </IconButton> : <IconButton onClick={() => setCollapsed(!collapsed)}>
                            <MenuOpen sx={{ color: "black", fontSize: 28 }} />
                        </IconButton>
                    }
                </Stack>
                <Menu
                    menuItemStyles={{
                        button: {
                            '&:hover': {
                                backgroundColor: '#e6e6e6',
                            },
                        },
                    }}
                >
                    {menus.map((menu, index) => {
                        return (
                            <div key={index}>
                                <Divider />
                                <MenuItem
                                    icon={getMenuIcon(menu)}
                                    onClick={() => setActiveComponent(menu)}
                                    rootStyles={{
                                        fontSize: 19,
                                        backgroundColor: menu === activeComponent ? "lightgrey" : ""
                                    }}
                                >
                                    {menu}
                                </MenuItem>
                            </div>
                        )
                    })}
                    <Divider />
                </Menu>
            </Sidebar>
            <Box sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                flexGrow: 1,
                backgroundColor: "#EFEFEF",
                overflow: 'auto',
            }}>
                {renderActiveComponent()}
            </Box>
        </Box>
    );
}

export default SideBar;